__turbopack_context__.v({
  "cta": "_4cPH2W_cta",
  "eyebrow": "_4cPH2W_eyebrow",
  "imageWrapper": "_4cPH2W_imageWrapper",
  "info": "_4cPH2W_info",
  "infoContainer": "_4cPH2W_infoContainer",
  "promoCard": "_4cPH2W_promoCard",
  "title": "_4cPH2W_title",
});
